import { ATexts } from '../../services/ATexts';
import type { TeamBody, UserBody } from '../../api/types/users.types';

/** The texts only the Users module shows, and what is built from a record — names for headlines and cards. */
class UsersTextsClass extends ATexts {
    public readonly PasswordsDiffer = 'Die Passwörter stimmen nicht überein.';
    public readonly UserUnknown = 'Diesen Benutzer gibt es nicht, oder er ist nicht freigeschaltet.';
    public readonly AccountPending = 'Konto noch nicht freigeschaltet';
    public readonly Active = 'Aktiv';
    public readonly Back = 'Zurück';
    public readonly BackToUsers = 'Zurück zu den Benutzern';
    public readonly CodeCheck = 'Code prüfen';
    public readonly Confirm = 'Bestätigen';
    public readonly DataSaved = 'Deine Daten wurden erfolgreich gespeichert.';
    public readonly Designation = 'Bezeichnung';
    public readonly EmailAddress = 'E-Mail-Adresse';
    public readonly EmailCode = 'Code aus der E-Mail';
    public readonly Hint = 'Hinweis';
    public readonly IsSystem = 'System?';
    public readonly LastWork = 'Zuletzt aktiv';
    public readonly Link = 'Verknüpfen';
    public readonly LinkLower = 'verknüpfen';
    public readonly Linked = 'Verknüpft';
    public readonly LinkedAccount = 'Verknüpft ({account})';
    public readonly LinkedWith = 'Verknüpft mit {account}';
    public readonly LoggingOut = 'Du wirst abgemeldet…';
    public readonly LoginCode = 'Anmeldecode';
    public readonly LoginCodeSent = 'Wir haben Dir einen Anmeldecode an {hint} geschickt.';
    public readonly LoginIntro = 'Du bist derzeit nicht angemeldet. Bitte melde Dich mit Deinem Benutzernamen oder Deiner E-Mail-Adresse an.';
    public readonly Logout = 'Abmelden';
    public readonly LogoutConfirm = 'Ja, abmelden';
    public readonly LogoutQuestion = 'Willst Du Dich wirklich abmelden?';
    public readonly Microsoft = 'Microsoft';
    public readonly MicrosoftAccount = 'Microsoft-Konto';
    public readonly MicrosoftChecking = 'Die Anmeldung bei Microsoft wird geprüft …';
    public readonly MicrosoftDevOrigin = 'In der Entwicklung funktioniert die Microsoft-Anmeldung nur unter {origin}.';
    public readonly MicrosoftLinked = 'Das Microsoft-Konto wurde erfolgreich verknüpft.';
    public readonly MicrosoftNotConfigured = 'Die Microsoft-Anmeldung ist nicht konfiguriert. Bitte an Alf wenden!';
    public readonly MicrosoftNotLinked =
        'Es ist kein Microsoft-Konto verknüpft. Du kannst Dein Benutzerkonto mit einem Microsoft-Konto verknüpfen, um Dich per Single Sign-On anzumelden.';
    public readonly MicrosoftUnlink = 'Microsoft-Verknüpfung lösen';
    public readonly MicrosoftUnlinked = 'Die Verknüpfung zum Microsoft-Konto wurde erfolgreich gelöst.';
    public readonly MyData = 'Meine Daten';
    public readonly MyDataEdit = 'Meine Daten bearbeiten';
    public readonly MyOrganizations = 'Meine Firmen';
    public readonly Next = 'Weiter';
    public readonly NotSetUp = 'Nicht eingerichtet';
    public readonly OrEmail = 'oder E-Mail-Adresse';
    public readonly Password = 'Passwort';
    public readonly PasswordChange = 'Passwort ändern';
    public readonly PasswordChangeIntro = 'Gib Dein bisheriges und Dein neues Passwort ein. Das neue darf keine Leerzeichen enthalten.';
    public readonly PasswordChanged = 'Dein Passwort wurde erfolgreich geändert.';
    public readonly PasswordChangedLogin = 'Dein Passwort ist geändert. Melde Dich jetzt damit an.';
    public readonly PasswordChangedMail = 'Dein Passwort ist geändert. Du bekommst dazu noch eine E-Mail.';
    public readonly PasswordEnter = 'Bitte gib Dein Passwort ein.';
    public readonly PasswordForcedIntro = 'Bevor es weitergeht, ändere bitte Dein Passwort. Das bisherige hast Du per E-Mail bekommen.';
    public readonly PasswordForgotten = 'Passwort vergessen';
    public readonly PasswordNew = 'Neues Passwort';
    public readonly PasswordNewRepeat = 'Neues Passwort wiederholen';
    public readonly PasswordOld = 'Bisheriges Passwort';
    public readonly PasswordSave = 'Passwort speichern';
    public readonly PasswordSend = 'Passwort senden';
    public readonly PasswordSent = 'Ein neues Passwort wurde an den Benutzer gesendet.';
    public readonly PendingGreeting = 'Hallo {name}, Du bist angemeldet, aber Dein Benutzerkonto ist noch keinem Team zugewiesen.';
    public readonly PendingHint =
        'Sobald ein Administrator Dich dem Team USER zuweist, stehen Dir alle Funktionen zur Verfügung. Bis dahin kannst Du nur Dein Passwort ändern oder Dich abmelden.';
    public readonly PersonalAccount = 'Persönliches Konto';
    public readonly Register = 'Registrieren';
    public readonly RegisterCode = 'Freischaltcode';
    public readonly RegisterCodeSent = 'Wir haben Dir einen Freischaltcode an {email} geschickt.';
    public readonly RegisterConfirm = 'Ja, registrieren';
    public readonly RegisterQuestion = 'Für {username} gibt es noch kein Konto. Möchtest Du Dich mit {email} registrieren?';
    public readonly ResetCodeSent = 'Wir haben Dir einen Code geschickt. Gib ihn ein, dann kannst Du ein neues Passwort festlegen.';
    public readonly ResetCodeValid = 'Der Code stimmt. Lege jetzt Dein neues Passwort fest — ohne Leerzeichen.';
    public readonly Success = 'Erfolgreich';
    public readonly SystemTeamAcronymHint = 'Genau drei Großbuchstaben.';
    public readonly Team = 'Team';
    public readonly TeamAcronymHint = 'Genau drei Buchstaben, mindestens ein Kleinbuchstabe – nur System-Teams sind ganz in Großbuchstaben.';
    public readonly TeamCard = 'Teamkarte';
    public readonly TeamCreate = 'Team anlegen';
    public readonly TeamDelete = 'Team löschen';
    public readonly TeamEdit = 'Team bearbeiten';
    public readonly TeamFallback = 'Team #{id}';
    public readonly TeamHasUsers = 'Das Team hat noch Benutzer';
    public readonly TeamId = 'Team-ID';
    public readonly TeamImplied = 'Durch ein höheres Team enthalten';
    public readonly TeamNameHint = 'Mindestens ein Groß- und ein Kleinbuchstabe – nur System-Teams sind ganz in Großbuchstaben.';
    public readonly TeamNoUser = 'Diesem Team ist kein Benutzer zugewiesen.';
    public readonly TeamProtected = 'Ein System-Team kann nicht gelöscht werden';
    public readonly TeamRemove = 'Team entfernen';
    public readonly TeamRemoveUser = 'Aus Team entfernen';
    public readonly TeamsEdit = 'Teams bearbeiten';
    public readonly TeamsEmpty = 'Es gibt noch keine Teams.';
    public readonly Test = 'Testen';
    public readonly TestLower = 'testen';
    public readonly TfaApp = 'TFA-App';
    public readonly TfaCode = '6-stelliger Code aus der App';
    public readonly TfaCodeValid = 'Der Code ist gültig! Die Verbindung zur Authenticator-App funktioniert einwandfrei.';
    public readonly TfaConfirmCode = 'Gib anschließend den 6-stelligen Code aus der App ein, um die Verknüpfung zu bestätigen:';
    public readonly TfaEnterCode = 'Bitte gib den aktuellen 6-stelligen Code aus Deiner Authenticator-App ein.';
    public readonly TfaForcedIntro = 'Bevor es weitergeht, richte bitte die 2-Faktor-Authentifizierung (TFA-App) für Dein Benutzerkonto ein.';
    public readonly TfaKey = 'Schlüssel';
    public readonly TfaLink = 'TFA-App verknüpfen';
    public readonly TfaLinked = 'Die TFA-App wurde erfolgreich verknüpft.';
    public readonly TfaNotLinked =
        'Es ist keine Authenticator-App verknüpft. Du kannst Google Authenticator, Microsoft Authenticator oder eine andere kompatible App zur 2-Faktor-Authentifizierung verwenden.';
    public readonly TfaNoticeAfter = 'eine TFA-App für Dein Benutzerkonto ein:';
    public readonly TfaNoticeBefore = 'Bitte richte bis zum';
    public readonly TfaScan = 'Scanne diesen QR-Code mit Deiner Authenticator-App (z. B. Google Authenticator, Microsoft Authenticator) oder gib den Schlüssel manuell ein:';
    public readonly TfaSetup = 'TFA-App einrichten';
    public readonly TfaSetupLoading = 'Einrichtungsdaten werden geladen…';
    public readonly TfaTest = 'TFA-App testen';
    public readonly TfaTestCode = 'Gib den aktuellen 6-stelligen Code aus Deiner Authenticator-App ein, um zu prüfen, ob die Verknüpfung korrekt funktioniert:';
    public readonly TfaUnlink = 'TFA-Verknüpfung lösen';
    public readonly TfaUnlinked = 'Die Verknüpfung zur TFA-App wurde erfolgreich gelöst.';
    public readonly ToAccount = 'Zu Mein Konto';
    public readonly ToLogin = 'Zur Anmeldung';
    public readonly Unlock = 'Freischalten';
    public readonly UserCard = 'Benutzerkarte';
    public readonly UserCount = 'Anzahl der Benutzer';
    public readonly UserCreate = 'Benutzer anlegen';
    public readonly UserDelete = 'Benutzer löschen';
    public readonly UserEdit = 'Benutzer bearbeiten';
    public readonly UserFallback = 'Benutzer #{id}';
    public readonly UserMicrosoftUnlinked = 'Die Microsoft-Verknüpfung des Benutzers wurde erfolgreich gelöst.';
    public readonly UserNoSelfDelete = 'Du darfst Dich nicht selbst löschen';
    public readonly UserNoTeam = 'Diesem Benutzer ist kein Team zugewiesen.';
    public readonly UserTfaUnlinked = 'Die TFA-App-Verknüpfung des Benutzers wurde erfolgreich gelöst.';
    public readonly Username = 'Benutzername';
    public readonly UsersEmpty = 'Es gibt noch keine Benutzer.';

    public getTeamName(team: Pick<TeamBody, 'team_id' | 'team'>): string {
        return team.team || this.format(this.TeamFallback, { id: team.team_id });
    }

    public getUserName(user: Pick<UserBody, 'user_id' | 'username'>): string {
        return user.username || this.format(this.UserFallback, { id: user.user_id });
    }
}

export const UsersTexts = new UsersTextsClass();
